<template>
  <div class="vi-product-detail">
    <vi-biz-table :data="tableData" :columns="tableColumns" :show-header="false" class="table-no-hover" />
  </div>
</template>

<script>
import numeral from 'numeral';
import ProductDetail from './product-detail.vue';

export default {
  name: 'TtamProductDetailsSkuRows',
  props: {
    row: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    ProductDetail,
  },
  computed: {
    tableData() {
      return this.row?.skuInfos || [];
    },
    tableColumns() {
      // return getSkuTableColumns(this);
      return [
        {
          key: 'spu_id',
          width: 448, // 356 + 44 + 48 border-box 92是左边距
          className: 'column-sku-detail',
          formatter: row => (
            <ProductDetail
              product={row}
              disabled={false}
              picture={row.picture}
              title={row.title}
              id={`SKU ID: ${row.sku_id}`}
            />
          ),
        },
        {
          key: 'price',
          width: 150,
          align: 'right',
          formatter: row => {
            const { price } = row;
            return `${this.separator(price?.price || '')} ${price?.price_unit}`;
          },
        },
        {
          key: 'category',
          formatter: row => row.category?.name,
        },
        // {
        //   key: 'storefront_status',
        //   width: 250,
        //   align: 'left',
        //   hidden: true, // 占位对齐用，该字段sku没有;1P不支持展开，所以展开情况下必然是3P有storefront_status
        // }
      ];
    },
  },
  methods: {
    separator(value, format = '0,0.[00]') {
      return numeral(value).format(format);
    },
  },
};
</script>
<style lang="scss">
.vi-product-detail {
  > .biz-table {
    .vi-table__row {
      background: #f2f2f2;
    }
    .column-sku-detail {
      padding-left: 92px;
    }
    .vi-table th.is-leaf,
    .vi-table td {
      border: none;
    }
  }
}
</style>
